
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaProduto from '../../../../../lib/json/consultas/Produtos.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import SelectContaContabil from "../../../../components/Select/ContaContabil";

function FichaProduto(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idProduto, empresaFilialCompras } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialCompras);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialCompras);

    // Consulta do grid
    var consultaDefault  = ConsultaProduto.consulta + (idProduto ? ` AND B1_COD = '${idProduto}'` : '');

    const [campoCodigo, setCampoCodigo]       = useState('0');
    const [campoDescricao, setCampoDescricao] = useState('');
    const [campoOperacional, setCampoOperacional] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCorporativo, setCampoCorporativo] = useState({value: '', label: 'Selecione a Conta Contábil'});

    useEffect(() => {
        if (idProduto){
            loadProduto();
        }
    }, []);

    // Processa consulta do grid
    const loadProduto = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaProduto.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
        
        if (retConsulta.data){
            setCampoCodigo(retConsulta.data[0].B1_COD);
            setCampoDescricao(retConsulta.data[0].DESCRI);
            setCampoOperacional({value: retConsulta.data[0].B1_XCONTA, label: ''});
            setCampoCorporativo({value: retConsulta.data[0].B1_CONTA, label: ''});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return;
        }

        const cJSON = { 
            ACAO: idProduto ? 'INCLUIR' : 'ALTERAR',
            B1_COD: campoCodigo,
            B1_XCONTA: campoOperacional.value,
            B1_CONTA: campoCorporativo.value,            
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('PRODUTO', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
        }
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Produto" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={true}                    
                            />
                        </Col>

                        <Col md="10" xs="12">
                            <InputGeral 
                                label="Descrição"
                                tipo='text'
                                value={campoDescricao}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoDescricao(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h5>Conta Contábil - Configuração: </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoOperacional}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoOperacional}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="6" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCorporativo}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCorporativo}
                                disabled={disabledForm}
                            />
                        </Col>                        
                    </Row>
                </>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaProduto;